module.exports = __webpack_public_path__ + "static/media/cleaningppl.4cf0518f.png";